import { FC, ReactNode } from 'react';

import NewsNavbar from '@/components/news/NewsNavbarV2';
import NewsTopSearch from '@/components/news/NewsTopSearch';

import RootLayouts from './Rootlayouts';

interface NewsLayoutsProps {
  children: ReactNode;
}

const NewsLayouts: FC<NewsLayoutsProps> = ({ children }) => {
  return (
    <RootLayouts>
      <main>
        <NewsNavbar />
        <NewsTopSearch />
        <section className="mx-auto w-full px-2 md:px-4 lg:max-w-[73.75rem] 2xl:max-w-screen-xl">{children}</section>
      </main>
    </RootLayouts>
  );
};

export default NewsLayouts;
